// 数据总览
<template>
  <div>
    <div class="data-screening-box">
      <div class="data-screening-title">
        <ul class="condition-list clearfix">
          <li>
            <el-select v-model="timeStatisticsType" @change="getStatisticalDataFun()" placeholder="请选择">
              <el-option
                v-for="item in sjtjfsOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </li>
        </ul>
      </div>
      <div class="data-screening-content data-screening-content-np">
        <div class="statistics-box clearfix">
          <a @click="statisticsTypeFun(1)" :class="statisticsType==1?'selected':''">
            <p>{{totalData.totalNum}}</p>
            <p>总调用数量（次）</p>
          </a>
          <a @click="statisticsTypeFun(2)" :class="statisticsType==2?'selected':''">
            <p>{{totalData.totalInAmount}}</p>
            <p>总收入金额（元）</p>
          </a>
          <a @click="statisticsTypeFun(3)" :class="statisticsType==3?'selected':''">
            <p>{{totalData.totalCostAmount}}</p>
            <p>总成本金额（元）</p>
          </a>
        </div>
      </div>
    </div>
    <div class="data-screening-box" v-if="totalData.tableList && totalData.tableList.length>0 && statisticsType==1">
      <div class="data-screening-content data-screening-content-np">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="(item,index) in totalData.tableList" :key="index" :label="item.interName" :name="item.interId">
            <div class="table-box">
              <el-table
                v-if="activeName==item.interId"
                :data="item.children"
                border
                header-row-class-name="tableHead"
                style="width: 100%">
                <el-table-column
                  prop="interName"
                  label="接口名称"
                  min-width="52%">
                </el-table-column>
                <el-table-column
                  prop="totalNum"
                  label="总调用次数（次）"
                  min-width="16%">
                </el-table-column>
                <el-table-column
                  prop="totalInAmount"
                  label="总收入（元）"
                  min-width="16%">
                </el-table-column>
                <el-table-column
                  prop="totalCostAmount"
                  label="总成本（元）"
                  min-width="16%">
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="data-screening-box">
      <div class="data-screening-title">
        <ul class="condition-list clearfix">
          <li>
            <el-select v-model="picSelect.quickTime" placeholder="请选择" @change="quickTimeFun">
              <el-option
                v-for="item in sjOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li>
            <el-date-picker
              v-model="picSelect.timeFrame"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
              @change="dataPicFun()">
            </el-date-picker>
          </li>
          <li v-if="totalData.tableList && totalData.tableList.length>0">
            <el-cascader @change="selectedType" v-model="selectedInterId" :options="totalData.tableList" :props="optionProps" placeholder="选择接口" clearable></el-cascader>
          </li>
        </ul>
      </div>
      <div class="data-screening-content">
        <div id="infoPic"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataScreening',
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('UserInfo')),
      picSelect: {
        quickTime: 0,
        timeFrame: []
      },
      statisticsType: 1,
      timeStatisticsType: 1,
      totalData: {},
      sjtjfsOptions: [{
        label: '昨日接口统计调用',
        value: 1
      }, {
        label: '累计接口统计调用',
        value: 2
      }],
      sjOptions: [{
        label: '最近7天',
        value: 0
      }, {
        label: '最近15天',
        value: 1
      }, {
        label: '最近30天',
        value: 2
      }],
      activeName: '',
      optionProps: {
        label: 'interName',
        value: 'interId',
        children: 'children'
      },
      selectedInterId: [],
      picData: []
    }
  },
  mounted () {
    var _this = this
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
    _this.picSelect.timeFrame = [start, end]
    _this.infoPicChart = this.$echarts.init(document.getElementById('infoPic'))
    _this.infoPicChart.resize()
    _this.getStatisticalDataFun()
    _this.getPicData()
  },
  methods: {
    handleClick (tab, event) {
      var _this = this
      _this.$nextTick(() => {
      })
    },
    // 获取统计数据
    getStatisticalDataFun: function () {
      var _this = this
      _this.$axios.get('/requestApi/statistics/all/head?userId=' + _this.userInfo.id + '&type=' + _this.timeStatisticsType)
        .then(function (response) {
          let data = response.data
          // console.log("============"+JSON.stringify(data))
          if (data.meta.retCode == 0) {
            _this.totalData = data.data
            if (_this.totalData.tableList.length > 0) {
              _this.activeName = _this.totalData.tableList[0].interId
            };
          } else {
            console.log(data.meta.friendlyMsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 图片函数
    infoPicFun: function (ObjectChart) {
      var _this = this
      var xAxisArr = []
      var seriesArr = []
      var yName = ''
      if (_this.statisticsType == 1) {
        yName = '调用数量'
      } else if (_this.statisticsType == 2) {
        yName = '收入金额（元）'
      } else if (_this.statisticsType == 3) {
        yName = '成本金额（元）'
      };
      _this.picData.forEach(function (item) {
        xAxisArr.push(item.dateStr)
        if (_this.statisticsType == 1) {
          seriesArr.push(item.num)
        } else if (_this.statisticsType == 2) {
          seriesArr.push(item.inAmount)
        } else if (_this.statisticsType == 3) {
          seriesArr.push(item.costAmount)
        };
      })
      var objOption = {
        tooltip: {
          trigger: 'axis'
        },
        color: ['#3377ff'],
        xAxis: {
          type: 'category',
          data: xAxisArr,
          splitLine: {
            lineStyle: {
              color: '#ccc'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#ccc'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#000'
          }
        },
        yAxis: {
          name: yName,
          nameTextStyle: {
            color: '#000'
          },
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#ccc'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#000'
          }
        },
        series: [{
          name: yName,
          data: seriesArr,
          type: 'line',
          symbolSize: 10,
          areaStyle: {
            color: '#3377ff',
            opacity: 0.3
          }
        }]
      }
      ObjectChart.clear()
      ObjectChart.setOption(objOption)
    },
    // 时间范围变化触发(图片)
    dataPicFun: function () {
      var _this = this
      _this.picSelect.timeFrame[0] = this.$common.format(_this.picSelect.timeFrame[0], 'yyyy-MM-dd')
      _this.picSelect.timeFrame[1] = this.$common.format(_this.picSelect.timeFrame[1], 'yyyy-MM-dd')
      _this.getPicData()
    },
    // 快捷选择时间触发
    quickTimeFun: function () {
      var _this = this
      const end = new Date()
      const start = new Date()
      _this.picSelect.timeFrame = []
      if (_this.picSelect.quickTime == 0) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      } else if (_this.picSelect.quickTime == 1) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
      } else if (_this.picSelect.quickTime == 2) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      };
      _this.picSelect.timeFrame = [start, end]
      _this.getPicData()
    },
    // 获取图标数据
    getPicData: function () {
      var _this = this
      var sendData = new Object()
      sendData.userId = _this.userInfo.id
      sendData.type = _this.timeStatisticsType
      sendData.startDate = _this.picSelect.timeFrame[0]
      sendData.endDate = _this.picSelect.timeFrame[1]
      if (_this.selectedInterId.length == 0) {
        sendData.interId = ''
      } else {
        sendData.interId = _this.selectedInterId[1]
      };
      _this.$axios.post('/requestApi/statistics/all/bottom', sendData)
        .then(function (response) {
          let data = response.data
          // console.log("============"+JSON.stringify(data))
          if (data.meta.retCode == 0) {
            _this.picData = data.data
            _this.infoPicFun(_this.infoPicChart)
          } else {
            console.log(data.meta.friendlyMsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 图片选择接口获取值
    selectedType: function (value) {
      var _this = this
      _this.selectedInterId = value
      _this.getPicData()
    },
    // 选择图片统计类型
    statisticsTypeFun: function (type) {
      var _this = this
      _this.statisticsType = type
      _this.infoPicFun(_this.infoPicChart)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .statistics-box{width: 100%;}
  .statistics-box a{display: block; color: #333; float: left;width: 33.2%;border-left: 1px solid #e4e3e8;padding: 30px 0px;}
  .statistics-box .selected{background-color: #1989fa; color: #fff;}
  .statistics-box a:nth-of-type(1){border-left: 1px solid #e4e3e8;}
  .statistics-box a p{display: block;width: 100%;text-align: center;font-size: 16px;line-height: 24px;}
  .statistics-box a p:nth-of-type(1){font-size: 18px;}
  .table-box{padding: 20px;padding-top: 5px;}

</style>



// WEBPACK FOOTER //
// src/components/DataScreening.vue